module.exports = __webpack_public_path__ + "static/img/icon_plus.e0f0d377.png";